export default function LinkedInBanner({ settings }) {
  if (!settings.linkedin) return null;

  return (
    <section className="section">
      <div className="wrap">
        <div className="linked">
          <div>
            <h3>Zwischen den Anlässen läuft es auf LinkedIn.</h3>
            <p>
              Einladungen, kurze Fragen in die Runde und Gesuche aus dem Kreis. Die Gruppe ist offen
              für alle, die mit uns unterwegs sind.
            </p>
          </div>
          <a className="btn" href={settings.linkedin} target="_blank" rel="noreferrer">
            LinkedIn-Gruppe beitreten
          </a>
        </div>
      </div>
    </section>
  );
}
